/****************************************************
 * Module Name:  roleProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class RoleProxy {
  static GetAllRole = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/role",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllRoleMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/role/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllRoleDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/role/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleRole = (roleId, callback) => {
    let params = {
      id: roleId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/role",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckRoleAvailable = (role, callback) => {
    let params = {
      role: role,
    };

    restAPICall(
      Constants.MANAGER_URL + "/role/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddRole = (role, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/role",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(role),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateRole = (role, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/role",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(role),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllStockReport = (role, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/role/detail",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(role),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
